
import lazyLoad from '../plugins/PluginLazyLoad';

// Handle functionality of accordion menu
class Offer {
	constructor(element) {
	    // Find all necessary elements
	    this.element = element;
	    this.offerWrapper = document.querySelector(`[data-offer="wrapper"]`);
	    this.url = this.offerWrapper.dataset.url;
	    this.offerContent = document.querySelector(`[data-offer="content"]`);
	    this.offer_video = document.querySelector("[data-item='offer-video']");
	    this.offer_active_slide_line = document.querySelector("[data-item='offer-active-slide-line']");
	    this.container = document.querySelector(`[data-offer="items"]`);
	    this.tabsContent = document.querySelector(`[data-tabs="content"]`);
 
	    // Get menus
	    this.items = element.querySelectorAll(`[data-offer="item"]`);
 
	    // Init functionalities if all elements has been found
	    if (this.items.length > 0) {
		   this.init();
	    }
	    else {
		   console.error("missing elements to properly init offer")
	    }
	}
 
	init() {

		// add class if 6 or 7 items (class change font size)
		if (this.items.length > 5) {
			this.container.classList.add('less');
		}

		// find active element
		let activeElemnet = this.offerWrapper.querySelector(`[data-offer="item"][data-active="true"]`);

		// find previous and next element
		let prevActiveElement = this.getPreviousSibling(activeElemnet);
		let nextActiveElement = this.getNextSibling(activeElemnet);

		// add class to previous and next element
		if (prevActiveElement) {
			prevActiveElement.classList.add('prev');
		}
		if (nextActiveElement) {
			nextActiveElement.classList.add('next');
		}

		// get video src and play
		let video_src = activeElemnet.dataset.video;
		let src = this.offer_video.getAttribute('src');
		
		if (src == '') {
			this.offer_video.setAttribute('src', video_src);
		}
		this.offer_video.dataset.src = video_src;

		
		// calc new line position
		if (this.offer_active_slide_line) {
			setTimeout(() => {
				this.calcPosition(activeElemnet, this.container, this.offer_active_slide_line);
			},400);
		}
 
		// Add functionality to show submenu on click of item
		this.items.forEach(item => {
			let is_link = item.dataset.link;

			if (is_link == 'false') {
				item.addEventListener('click', (e) => {
					e.preventDefault();
		
					// on click show submenu 
					this.showContent(item);
				});
			}
		});
	}
 
	showContent(item) {
	    let id = item.dataset.id;
	    
		// find all active elemnets
		let activeElemnet = this.offerWrapper.querySelector(`[data-offer="item"][data-active="true"]`);

		// remove class and attributes if found active elements
		if (activeElemnet) {
			activeElemnet.setAttribute("data-active", "false");
			activeElemnet.classList.remove("active");
		}
	    
		// find previous element
		let prevElemnet = this.offerWrapper.querySelector(`[data-offer="item"].prev`);

		// remove class prev
		if (prevElemnet) {
			prevElemnet.classList.remove("prev");
		}
	    
		// find next element
		let nextElemnet = this.offerWrapper.querySelector(`[data-offer="item"].next`);

		// remove class next
		if (nextElemnet) {
			nextElemnet.classList.remove("next");
		}
	    
		// add class to new active alement
		item.classList.add("active");
		item.setAttribute("data-active", "true");

		// find previous and next new element
		let prevActiveElement = this.getPreviousSibling(item);
		let nextActiveElement = this.getNextSibling(item);

		// add class to previous and next element
		if (prevActiveElement) {
			prevActiveElement.classList.add('prev');
		}
		if (nextActiveElement) {
			nextActiveElement.classList.add('next');
		}

		// get new video src and play
		let video_src = item.dataset.video;
		this.offer_video.setAttribute('src', video_src);

		// find content active element
		let contentActiveElemnet = this.offerContent.querySelector(`[data-content="item"][data-active="true"]`);

		// remove class and attributes if found active element
		if (contentActiveElemnet) {
			contentActiveElemnet.setAttribute("data-active", "false");
			contentActiveElemnet.classList.remove("active");
		}

		// find new conetnt element
		let newContent =  this.offerContent.querySelector(`[data-content="item"][data-id="${id}"]`);
		let url = this.offerContent.dataset.url;
	    
		// add class to new active content alement
		newContent.classList.add("active");
		newContent.setAttribute("data-active", "true");

		if (url) {
			// find active tab
			let activeTab = newContent.querySelector(`[data-tabs="item"][data-active="true"]`);
			let tab_id = activeTab.dataset.id;
			let html = document.querySelector(`html`);
			let lang = html.getAttribute('lang');

			console.log(lang);

			fetch(url+"?id="+tab_id+"&lang="+lang, {
			method: 'GET',
			}).then(res => res.text())
			.then(data => {
				// Update content in container
				this.tabsContent.innerHTML = '';
				this.tabsContent.insertAdjacentHTML('beforeend', data);
	
				// init section slider
				const section_slider = $("[data-item='section-slider']");
				
				if (section_slider.length > 0) {
				$("[data-item='section-slider']").slick({
					dots: false,
					arrows: true,
					infinite: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					lazyLoad: 'ondemand',
					responsive: [
						{
						breakpoint: 991,
						settings: {
							slidesToShow: 3,
						}
						},
						{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
						}
						},
						{
						breakpoint: 467,
						settings: {
							slidesToShow: 1,
						}
						}
					]
					});
				}

				setTimeout(() => {
				new lazyLoad("[data-lazy='active']", {
					rootMargin: "200px",
					classDefault: 'lazy-image',
					classOnLoad: 'lazy-image--active',
				})
			},700);
			})
		}

		// calc new line position
		if (this.offer_active_slide_line) {
			setTimeout(() => {
				this.calcPosition(item, this.container, this.offer_active_slide_line);
			},700);
		}
 
	}

	getNextSibling(elem, selector) {

		// Get the next sibling element
		var sibling = elem.nextElementSibling;
	
		// If there's no selector, return the first sibling
		if (!selector) return sibling;
	
		// If the sibling matches our selector, use it
		// If not, jump to the next sibling and continue the loop
		while (sibling) {
			if (sibling.matches(selector)) return sibling;
			sibling = sibling.nextElementSibling
		}
	
	};

	getPreviousSibling(elem, selector) {

		// Get the next sibling element
		var sibling = elem.previousElementSibling;
	
		// If there's no selector, return the first sibling
		if (!selector) return sibling;
	
		// If the sibling matches our selector, use it
		// If not, jump to the next sibling and continue the loop
		while (sibling) {
			if (sibling.matches(selector)) return sibling;
			sibling = sibling.previousElementSibling;
		}
	
	};

      // calc left line position 
	 calcPosition(element, container, active_slide_line) {
          let top_container = container.offsetTop;
          let top = element.offsetTop + top_container;
          let height = element.offsetHeight;
          
          //console.log('offer');
          //console.log(top_container);
          //console.log(top);
          //console.log(height);
          
          active_slide_line.style.top = top + "px";
          active_slide_line.style.height = height + "px";
     };
 }
 
 window.addEventListener('load', () => {
	// Get all offer list that need to use this functionality
	const offerWrapper = document.querySelectorAll(`[data-offer="wrapper"]`);
	if (offerWrapper.length > 0) {
		offerWrapper.forEach(offer => {
		   // Find all offer elements
		   const offerList = offer.querySelectorAll(`[data-offer="items"]`);
		   
		   offerList.forEach(element => {
			  // Init functionality for every element
			  new Offer(element);
		   })
	    })
	}
 })